class Menu {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.closeBtn = self.elem.querySelector('.menu__close');
        self.hamburger = document.querySelector('.hamburger');
        self.menuItems = self.elem.querySelectorAll('.menu__nav_item__link');
        self.menuItemsTarget = self.elem.querySelectorAll('.menu__nav_item__link__target');
    }

    init() {
        let self = this;

        self.closeBtn.addEventListener('click', self.closeMenu.bind(this), false);
        self.hamburger.addEventListener('click', self.openMenu.bind(this), false);
        self.dropdowns();
    }

    closeMenu() {
        this.elem.classList.remove('active');
    }

    openMenu() {
        this.elem.classList.add('active');
    }

    setActivePage() {
        let self = this;
        let pathName = location.href;

        // self.menuItems.forEach(item => {
        //     if(item.href == pathName) {
        //         item.classList.add('active');
        //     } else {
        //         item.classList.remove('active');
        //     }
        // });
    }

    dropdowns() {
        let self = this;

        self.menuItemsTarget.forEach(link => {
            link.addEventListener('click', evt => {
                this.closeOtherDropdowns(link);
                this.toggleDropdown(link);
            });
        });
    }

    toggleDropdown(link) {
        let self = this;

        let id = link.getAttribute('data-nav-dropdown');
        let dropdown = self.elem.querySelectorAll("[data-nav-dropdown-menu='" + id + "']");

        dropdown.forEach(elem => {
            elem.classList.toggle('active');
        });

        link.classList.toggle('active');
    }

    closeOtherDropdowns(link) {
        let self = this;

        let id = link.getAttribute('data-nav-dropdown');
        let dropdowns = self.elem.querySelectorAll("[data-nav-dropdown-menu]");
        let links = self.elem.querySelectorAll("[data-nav-dropdown]");

        links.forEach(elem => {
            if (elem.getAttribute('data-nav-dropdown') !== id) {
                elem.classList.remove('active');
            }
        });

        dropdowns.forEach(elem => {
            if (elem.getAttribute('data-nav-dropdown-menu') !== id) {
                elem.classList.remove('active');
            }
        });
    }
}
export default Menu;
